import Pagination from 'componets/pagination/pagination';

export default Pagination;
